export default [{
    name: 'Договор долевого участия (214-ФЗ)',
    key: 'fz214',
}, {
    name: 'Договор уступки права требования',
    key: 'dupt',
}, {
    name: 'Договор ЖСК',
    key: 'dzhsk',
}, {
    name: 'Предварительный договор купли-продажи',
    key: 'pdkp',
}, {
    name: 'Договор инвестирования',
    key: 'investment',
}, {
    name: 'Свободная продажа',
    key: 'free',
}];
